import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * CardWW5 (Paytree) API
 * Оплата международными банковскими картами VISA/MC в долларах через провайдера Paytree.
 * Структура эндпоинтов идентична cardww1–cardww4, отличается только путь /api/cardww5/
 * и поле `cardww5` в пакетах /api/topup/.
 */

/**
 * Получить конфигурацию cardww5 (курсы и лимиты)
 */
export const fetchCardWw5Config = async () => {
  try {
    const response = await apiService.makeRequest('/api/cardww5/')

    if (response.cardww5) {
      return { ...response.cardww5, promo: response.promo || null }
    }

    throw new Error('Invalid response format: cardww5 config not found')
  } catch (error) {
    console.error('Error fetching CardWW5 config:', error)
    throw error
  }
}

/**
 * Получить пакеты для cardww5 из общего списка тарифов /api/topup/
 * Фильтрует только те пакеты, у которых есть поле cardww5
 */
export const fetchCardWw5Packages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.cardww5 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching CardWW5 packages:', error)
    throw error
  }
}

// Нормализация ошибок бэкенда cardww5 к единому виду
const normalizeCardWw5CreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'PAYMENT_LIMIT'

  return response.error
}

/**
 * Создать платеж cardww5 по сумме в долларах
 */
export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/cardww5/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    const normalizedError = normalizeCardWw5CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW5 payment by dollars:', error)
    throw error
  }
}

/**
 * Создать платеж cardww5 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/cardww5/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardWw5CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW5 payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату cardww5 через Telegram WebApp API
 */
export const openCardWw5Payment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'CardWW5', paymentWindow)
}

export default {
  fetchCardWw5Config,
  fetchCardWw5Packages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCardWw5Payment
}
